
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component
export default class GsButtonIcon extends Vue {
  @Prop() size: string | undefined;
  @Prop() icon: string;
  @Prop() src: string;
  @Prop() background: string;
  @Prop() active: boolean;
  @Prop({ default: false }) disabled: boolean;

  isActive = false;
  visible = false;

  @Watch("active")
  onActiveChange() {
    this.isActive = this.active;
  }

  handleClick(evt: any) {
    if (this.disabled) {
      return;
    }
    this.$emit("click", evt);
    if (this.active) {
      this.isActive = !this.isActive;
    }

    if ((this.$refs.button as any).index !== undefined) {
      let setActiveIndex = new Event("setActiveIndex");
      // 触发事件
      (this.$refs.button as HTMLDivElement).dispatchEvent(setActiveIndex);
    }
  }

  handleBlur() {
    setTimeout(() => {
      this.visible = false;
    }, 100);
  }

  mouseover() {}

  mouseleave() {}

  mounted() {}
}
